module.exports = __webpack_public_path__ + "img/a011_10.10cc20d8.png";